
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/upsc-psychology-mains-test-series",
      function () {
        return require("private-next-pages/upsc-psychology-mains-test-series/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/upsc-psychology-mains-test-series"])
      });
    }
  